import { render, staticRenderFns } from "./ViewOrderHistory.vue?vue&type=template&id=1b27326b"
import script from "./ViewOrderHistory.vue?vue&type=script&lang=js"
export * from "./ViewOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./ViewOrderHistory.vue?vue&type=style&index=0&id=1b27326b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports